import { HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ERROR_412_EXACT_MAPPING, ERROR_412_PATTERNS, ERROR_FALLBACK_MAPPING } from './error-mapping.config';

@Injectable({
    providedIn: 'root'
})
export class ErrorHandlerService {
    private readonly translate = inject(TranslateService);

    public getErrorMessageTranslation(error: HttpErrorResponse): string {
        if (error.status === 412) {
            const message = error.error?.message || '';

            // Try exact match first (fastest)
            const exactMatch = ERROR_412_EXACT_MAPPING.get(message);
            if (exactMatch) {
                return this.translate.instant(exactMatch);
            }

            // Try pattern matching
            const patternMatch = ERROR_412_PATTERNS.find(({ pattern }) => {
                if (typeof pattern === 'string') {
                    return message.toLowerCase().includes(pattern.toLowerCase());
                }
                return pattern.test(message);
            });

            if (patternMatch) {
                return this.translate.instant(patternMatch.key);
            }
        }

        return this.translate.instant(ERROR_FALLBACK_MAPPING.get(error.status) || 'generic-errors.generic');
    }
}
